import { checkMomentInPast } from './checkMomentInPast';

/**
 * Define se um item deve permanecer habilitado com base no momento e na cota disponível.
 */
const isScheduleAvailable = (schedule, currentCount, totalAmount) => {
  const isNotPast = !checkMomentInPast(schedule.date, schedule.time);
  const hasNotReachedItsMaximum = currentCount <= totalAmount;
  return isNotPast && hasNotReachedItsMaximum;
};

/**
 * Aplica as regras de negócio de exibição e limite de visitas para os agendamentos.
 * - Não é evento passado
 * - Não atingiu máxima quantidade de visitas do PAD Visit
 * * @param {Array} scheduleEvents - Array de eventos de agendamento vindo do scheduleMap
 * @param {number} totalAmount - Quantidade máxima de visitas permitidas
 * @returns {Array} Agendamentos atualizados com a flag 'isEnabledForSelection'
 */
export const applyScheduleDisplayRules = (scheduleEvents, totalAmount) => {
  let enabledCounter = 0;

  return scheduleEvents.map(schedule => {
    const isCandidate = !checkMomentInPast(schedule.date, schedule.time);

    if (isCandidate) {
      enabledCounter++;
    }

    return {
      ...schedule,
      isEnabledForSelection: isScheduleAvailable(schedule, enabledCounter, totalAmount)
    };
  });
};
